import api from '../../api/api.js'
import sellerpurchase from '../../api/moudles/sellerpurchase.js'
import { Message } from 'element-ui'

import {
   GET_PURCHASE_ORDER,
   GET_PURCHASE_TATAL
  

} from '../mutation-types'

const state = () => ({
	purchaseorderList:[],
	pruchaseTotal:0,
	purchaseOrderNum:0
})

const getters = {}

const actions = {
	getPurchaseOrderNum({state,commit},payload) {
		api
		.getPurchaseOrderNum(payload)
		.then(res => {
			if(res.code === 200){
				console.log('入库单待处理数量',res.data)
				state.purchaseOrderNum=res.data.pcOrderNum+res.data.customOrderNum
			}
		})
	},
	 //获取卖家采购数据
	getPurchaseOrder({commit},payload) {
		sellerpurchase
		.getPurchaseOrder(payload)
		.then(res => {
			if(res.code === 200) {
				console.log(res.data)
				commit(GET_PURCHASE_ORDER,res.data)
				commit(GET_PURCHASE_TATAL,res.data)
			}
		})
	},
	//删除入库单
	removePurchaseOrder({state, commit},payload) {
		sellerpurchase
		.removePurchaseOrder(payload)
		.then(res => {
			if(res.code === 200) {
				Message({
					message: '成功删除入库单',
					type: 'success'
				})
				
				state.purchaseorderList.forEach((p,index) => {
					
					if(p.purchaseOrderId === payload.purchaseOrderId) {
						state.purchaseorderList.splice(index,1)
					}
				})
			}else{
				Message({
					message: res.msg,
					type: 'warning'
				})
			}
		})
	},
	

}

const mutations = {
	[GET_PURCHASE_ORDER]:(state,data) =>{
		let newdata=data.list
		newdata.forEach(p => {
			p.checked=false
			let totalnum=0
			p.totaoVolumn=0
			p.variantList.forEach(k => {
				totalnum += k.variantNum
				p.totaoVolumn += (k.packageHeight/100)*(k.packageLength/100)*(k.packageWidth/100)*k.variantNum
			})
			p.quantity=totalnum
		})
		state.purchaseorderList =newdata

		console.log('newdata',newdata)
	},
	
	
	[GET_PURCHASE_TATAL]:(state,data) =>{
		state.pruchaseTotal =data.count
	}
	

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}